import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
import { ArrowRightIcon, XIcon } from 'lucide-react';
interface BottomCTAProps {
  onCTAClick: () => void;
  riskLevel: string;
  quizCompleted: boolean;
}
export function BottomCTA({
  onCTAClick,
  riskLevel,
  quizCompleted
}: BottomCTAProps) {
  const [isVisible, setIsVisible] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  // Show CTA after scrolling or after 5 seconds
  useEffect(() => {
    const scrollTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    const handleScroll = () => {
      if (window.scrollY > 300 && !hasScrolled) {
        setHasScrolled(true);
        setIsVisible(true);
        clearTimeout(scrollTimer);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      clearTimeout(scrollTimer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [hasScrolled]);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 p-4 z-20 animate-fade-in" data-id="element-52">
      <div className="container mx-auto max-w-4xl" data-id="element-53">
        <div className="flex flex-col items-center md:flex-row md:justify-between" data-id="element-54">
          <div className="mb-3 md:mb-0 text-center md:text-left" data-id="element-55">
            <h3 className="font-semibold" data-id="element-56">
              {quizCompleted ? `${riskLevel === 'high' ? 'Ditt hem har hög risk' : riskLevel === 'medium' ? 'Ditt hem har medelrisk' : 'Bra grundskydd!'}` : 'Vill du veta om vårt larm passar just ditt hem?'}
            </h3>
            <ul className="text-sm hidden md:block" data-id="element-57">
              <li className="inline mr-4" data-id="element-58">✓ Kostnadsfri rådgivning</li>
              <li className="inline mr-4" data-id="element-59">✓ Rådgivare ringer upp</li>
              <li className="inline" data-id="element-60">✓ Ingen bindning</li>
            </ul>
          </div>
          <div className="flex items-center" data-id="element-61">
            <CTAButton onClick={onCTAClick} text="Ta reda på om det passar dig" primary icon={<ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-63" />} className="w-full md:w-auto shadow-md hover:shadow-lg" href="https://go.adt212.net/t/t?a=1960533651&as=1971362379&t=2&tk=1" data-id="element-62" />
            <button onClick={() => setIsVisible(false)} className="ml-2 p-2 text-gray-500 hover:text-gray-700 md:hidden" aria-label="Stäng" data-id="element-64">
              <XIcon className="h-5 w-5" data-id="element-65" />
            </button>
          </div>
        </div>
      </div>
    </div>;
}